import { Button, makeStyles, Paper, Table, TableBody,withStyles, TableCell, TableContainer, TableHead, TableRow, Typography, TextField, Tooltip, IconButton, Snackbar } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import Cookies from 'js-cookie';
import SearchIcon from '@material-ui/icons/Search';
import { useDispatch, useSelector } from 'react-redux';
import { DateField, PembayaranCombo, SingleDialog} from '../../component/molecules';
import { DataPelanggan } from '../../component/organism';
import { emptyDataPelanggan,getDataToPrint, emptyMessagePenjualan, getAllListPenjualan, getNewIDPenjualan, postPenjualanToAPI, resetAllFormPenjualan, setEmptyLoadDraft, getAllListPenjualanFromDraft, postPenjualanFromDraftToAPI, setMessagePenjualan } from '../../config/redux/action';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { addDays, format } from 'date-fns';
import CloseIcon from '@material-ui/icons/Close';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import NumberFormat from 'react-number-format';
import MuiAlert from '@material-ui/lab/Alert';
import PrintDialog from '../../component/organism/PrintDialog';
import { useHistory } from 'react-router-dom';
import { OpenDraft, Profit } from '../../component/assets';
import GetDataDraft from '../../component/organism/GetDataDraft';

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    return (
      <NumberFormat
        {...other}
        getInputRef={inputRef}
        onValueChange={(values) => {
            onChange({
              target: {
                name: props.name,
                value: values.value,
              },
            });
          }}
        thousandSeparator
        isNumericString
        prefix={'Rp '}
      />
    );
  }
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
const KeranjangPenjualan = () => {
    const {data} = useSelector(state => state.loginReducers);
    const [token,setToken] = useState(data.token);
    const {selected} = useSelector(state=>state.pelangganReducers);
    const {selectedNama} = selected;
    const dispatch = useDispatch();
    const{nofaktur,listPenjualan,loadingPenjualan,messagePenjualan,statusDraftPenjualan,dataDraftPenjualan} = useSelector(state=>state.penjualanReducers);
    const {listKeuntungan} = useSelector(state=>state.keuntunganReducers);
    const [totalPenjualan,setTotalPenjualan]=useState(0);
    const [statusLockOngkir,setStatusLockOngkir]=useState(true);
    const [statusLockDiskon,setStatusLockDiskon]=useState(true);
    const [grandTotal,setGrandTotal]=useState(0);
    const [totalModal,setTotalModal]=useState(0);
    const [totalLaba,setTotalLaba]=useState(0);
    const [openDraftDialog,setOpenDraftDialog]=useState(false);
    const [namaItem,setNamaItem]=useState("");
    const [totalItem,setTotalItem]=useState(0);
    if(token ===''){
        setToken(Cookies.get('u_tkn'));
    }
    const useStyle = makeStyles((theme)=>({
        root:{
            width:'100%',
            height:'100%',
        },
        content:{
            display:'flex',
            flexDirection:'column',
            alignItems:'center'
        },
        headerContent:{
            width:'90%',
            display:'flex',
            justifyContent:'center',
            alignItems:'center'
        },
        table:{
            marginTop:'5px',
            marginLeft:'0px',
            width:'90%',
            // maxWidth:'800px',
            [theme.breakpoints.up('md')]:{
                // marginLeft:'5%',
            },
        },
        tableContainer:{
            height:'520px',
            [theme.breakpoints.up('md')]:{
                height:'340px',
            },
        },page:{
            display:'flex',
            justifyContent:'space-between',
            width:'100%',
            margin:'0px',
        },
        OngkirWapper:{
            display:'flex',
            flexDirection:'column',
            alignItems:'flex-end',
            width:'90%',
            margin:'0px',
        },
        GrandTotal:{
            display:'flex',
            justifyContent:'space-between',
            width:'90%',
            marginTop:'10px',
            marginBottom:'10px',
        },
        textPage:{
            padding:'10px',
        },
        tableBottom:{
            display:'flex',
            flexDirection:'row',
            alignContent:'space-between'
        },
        divinder:{
            padding:'5px'
        },
        mainWapper:{
            display:'flex',
            flexDirection:'row',
            marginBottom:'5px',
            marginLeft:'0px',
            width:'100%',
            justifyContent:'center',
            alignItems:'center',
            [theme.breakpoints.down('xs')]:{
                flexDirection:'column'
            },
        },
        iconSearch:{
            marginTop:'35px',
            height:'10px',
        },
        input:{
            width:'150px',
            marginTop:'5px',
            marginLeft:'5px',
            [theme.breakpoints.up('md')]:{
                width:'150px',
                marginLeft:'5px',
            },
        },
        blokFaktur:{
            display:'flex',
            width:'350px',
            justifyContent:'center',
            marginTop:'10px',
            [theme.breakpoints.down('xs')]:{
                justifyContent:'flex-start',
            },
        },
        blokTempo:{
            display:'flex',
            width:'200px',
            justifyContent:'center',
            [theme.breakpoints.down('xs')]:{
                width:'350px',
                justifyContent:'flex-start',
            },
        },
        lock:{
            display:'flex',
            justifyContent:'center',
            alignItems:'flex-end'
        },
    }));
    const SytledTableCell = withStyles((theme)=>({
        head: {
            backgroundColor: 'grey',
            color: theme.palette.common.black,
          },
          body: {
            fontSize: 14,
            // border:'1px solid black'
          },
    }))(TableCell);
    const StyledTableRow = withStyles((theme) => ({
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
          },
        },
      }))(TableRow);
    const classes = useStyle();
    const [openSnackbar,setOpenSnackbar] = useState(false);
    const handleCloseSnackBar = () => {
        setOpenSnackbar(false);
        setTimeout(()=>{
            dispatch(emptyMessagePenjualan(""));
            // history.push('/historypembelian');
        },200)
    };
    const [openPelanggan,setOpenPelanggan]=useState(false);
    const dataPenjualan=(
        <div className={classes.content}>
            <div className={classes.headerContent}>
                <div style={{width:'60%',display:'flex',justifyContent:'flex-end',alignItems:'center',}}>
                    <Typography>Data Penjualan</Typography>
                    <Tooltip title="Ambil Data Draft">
                        <IconButton
                        onClick={()=>handleOpenDraftDialog()}><img src={OpenDraft} alt="openDraft"/></IconButton>
                    </Tooltip>
                </div>
                <div style={{width:'40%',display:'flex',justifyContent:'flex-end'}}>
                    <Tooltip title={"Rp "+new Intl.NumberFormat().format(totalLaba)}>
                        <IconButton><img src={Profit} alt="profit" style={{width:'20px',height:'20px'}}/></IconButton>
                    </Tooltip>
                </div>
            </div>
        <div className={classes.table}>
            <Paper>
                <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader aria-label="table barang" size="small">
                        <TableHead>
                            <TableRow>
                                <SytledTableCell width='10%' align="center">ID Barang</SytledTableCell>
                                <SytledTableCell width='35%' align="center">Nama Barang</SytledTableCell>
                                <SytledTableCell width='10%' align="center">Jumlah</SytledTableCell>
                                <SytledTableCell width='10%' align="center">Satuan</SytledTableCell>
                                <SytledTableCell width='10%' align="center">Catatan</SytledTableCell>
                                <SytledTableCell width='20%' align="center">Harga</SytledTableCell>
                                <SytledTableCell width='20%' align="center">Subtotal</SytledTableCell>
                                {statusDraftPenjualan==="Penjualan" ? 
                                <SytledTableCell width='3%' align="center"></SytledTableCell>
                                : null}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {listPenjualan.map((listPenjualans=>(
                                <StyledTableRow key={listPenjualans.idbarang}>
                                    <SytledTableCell align="center">{listPenjualans.idbarang}</SytledTableCell>
                                    <SytledTableCell align="center">{listPenjualans.namabarang}</SytledTableCell>
                                    <SytledTableCell align="center">{listPenjualans.jumlah}</SytledTableCell>
                                    <SytledTableCell align="center">{listPenjualans.satuan}</SytledTableCell>
                                    <SytledTableCell align="center">{listPenjualans.note}</SytledTableCell>
                                    <SytledTableCell align="center">{new Intl.NumberFormat().format(listPenjualans.harga)}</SytledTableCell>
                                    <SytledTableCell align="center">{new Intl.NumberFormat().format(listPenjualans.subtotal)}</SytledTableCell>
                                    {statusDraftPenjualan==="Penjualan" ? 
                                    <SytledTableCell align="center">
                                        <Tooltip title="Hapus dari list">
                                            <IconButton 
                                            size='small' onClick={()=>openDeletePenjualan(listPenjualans.idbarang,listPenjualans.namabarang)}>
                                                <CloseIcon style={{color:'red'}}/>
                                            </IconButton>
                                        </Tooltip>
                                    </SytledTableCell>
                                    : null}
                                </StyledTableRow>
                            )))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={classes.tableBottom}>
                    <div className={classes.page}>
                        <Typography>Total Item</Typography>
                        <Typography>{new Intl.NumberFormat().format(totalItem) + " Item"}</Typography>
                    </div>
                </div>
                <div className={classes.tableBottom}>
                    <div className={classes.page}>
                        <Typography>Total Penjualan</Typography>
                        <Typography>{new Intl.NumberFormat().format(totalPenjualan)}</Typography>
                    </div>
                </div>
            </Paper>
        </div>
        </div>
    )
    const handleClickOpenPelanggan = ()=>{
        setOpenPelanggan(true);
    }
    const handleClosePelanggan = () =>{
        setOpenPelanggan(false);
        setTimeout(()=>{
            dispatch(emptyDataPelanggan());
        },200)
        formik.setFieldValue('namapelanggan',selectedNama);
    }
    const validationSchema = yup.object().shape({
        tanggal:yup.date().max(new Date(),'Tanggal tidak boleh melebihi hari ini'),
        namapelanggan:yup.string().required('Nama pelanggan tidak boleh kosong'),
        jatuhtempo:yup.date().min(yup.ref('tanggal'),'Jatuh tempo tidak boleh kurang dari tanggal penjualan'),
        lamatempo:yup.number().min(0,'lama tempo tidak boleh kurang dari 0'),
        ongkir:yup.number().min(0,'Ongkir tidak boleh kurang dari 0'),
        diskon:yup.number().min(0,'Diskon tidak boleh kurang dari 0'),
        pembayaran:yup.string().required('Pembayaran belum diisi'),
      })
    const formik = useFormik({
        initialValues:{
            namapelanggan:selectedNama || '',
            tanggal:dataDraftPenjualan.tanggal,
            jatuhtempo:dataDraftPenjualan.jatuhtempo,
            pembayaran:dataDraftPenjualan.pembayaran,
            lamatempo:dataDraftPenjualan.lamatempo,
            ongkir:dataDraftPenjualan.ongkir,
            diskon:dataDraftPenjualan.diskon
        },
        validationSchema:validationSchema,
        onSubmit:(values)=>{
            var tempArr=[];
            for(var i=0;i<listPenjualan.length;i++){
                for(var j=i+1;j<listPenjualan.length;j++){
                    if(listPenjualan[i].idbarang===listPenjualan[j].idbarang && !tempArr.includes(listPenjualan[i].idbarang)){
                        tempArr.push(listPenjualan[i].idbarang);
                    }
                }
            }
            if(tempArr.length<1){
                if(statusDraftPenjualan==="Penjualan"){
                    const data = {
                        "idpenjualan":nofaktur,
                        "pelanggan":values.namapelanggan,
                        "tanggal":format(values.tanggal,'yyyy-MM-dd'),
                        "pembayaran":values.pembayaran,
                        "jatuhtempo":format(values.jatuhtempo,'yyyy-MM-dd'),
                        "diskon":values.diskon,
                        "total":grandTotal,
                        "ongkir":values.ongkir,
                        "status":"Penjualan",
                        "penjualan":totalPenjualan,
                        "modal":totalModal,
                        "keuntungan":parseInt(totalPenjualan)-parseInt(totalModal)+parseInt(values.ongkir)-parseInt(values.diskon),
                        "details":listPenjualan,
                        "detailsKeuntungan":listKeuntungan
                    }
                    dispatch(postPenjualanToAPI(data,token,setOpenSnackbar,setOpenPrint));
                }else if(statusDraftPenjualan==="Draft"){
                    const data = {
                        "idpenjualan":nofaktur,
                        "tanggal":format(values.tanggal,'yyyy-MM-dd'),
                        "diskon":values.diskon,
                        "ongkir":values.ongkir,
                        "status":"Penjualan",
                        "penjualan":totalPenjualan,
                        "modal":totalModal,
                        "keuntungan":parseInt(totalPenjualan)-parseInt(totalModal)+parseInt(values.ongkir)-parseInt(values.diskon),
                        "details":listPenjualan,
                        "detailsKeuntungan":listKeuntungan
                    }
                    dispatch(postPenjualanFromDraftToAPI(data,token,setOpenSnackbar,setOpenPrint));
                }
            }else{
                dispatch(setMessagePenjualan(
                    <div style={{margin:'0',textAlign:'center'}}>
                        <p>Penjualan gagal disimpan,</p>
                        <p>terdapat item yang sama dalam 1 keranjang penjualan</p>
                    </div>
                    ));
                setOpenSnackbar(true);
            }
        }
    })
    useEffect(() => {
        if(nofaktur === ''){
            dispatch(getNewIDPenjualan(format(formik.values.tanggal,'ddMMyy'),token));
        }
        if(listPenjualan.length>0){
            let totalPenjualan=listPenjualan.reduce((Penjualan,TotalP)=>{
                return Penjualan + TotalP.subtotal
            },0)
            setTotalPenjualan(totalPenjualan);
            let totalItemList=listPenjualan.reduce((Penjualan,TotalI)=>{
                return parseInt(Penjualan) + parseInt(TotalI.jumlah)
            },0)
            setTotalItem(totalItemList);
            let totalModal=listKeuntungan.reduce((Keuntungan,TotalK)=>{
                return Keuntungan + TotalK.subtotalmodal
            },0)
            setTotalModal(totalModal);
            let totalKeuntungan = listKeuntungan.reduce((Keuntungan,TotalL)=>{
                return Keuntungan + TotalL.laba
            },0)
            setTotalLaba(parseInt(totalKeuntungan) + parseInt(formik.values.ongkir) - parseInt(formik.values.diskon));
        }else{
            setTotalPenjualan(0);
            setTotalModal(0);
            setTotalLaba(0);
        }
        if(statusLockOngkir === true && statusLockDiskon === true){
            setGrandTotal(parseInt(totalPenjualan) + parseInt(formik.values.ongkir) - parseInt(formik.values.diskon));
        }
    }, [dispatch,nofaktur,token,formik.values.tanggal,listPenjualan,listKeuntungan,totalPenjualan,grandTotal,totalModal,
        formik.values.diskon,formik.values.ongkir,statusLockOngkir,statusLockDiskon,totalItem,totalLaba])
        
    const handleChangeTanggal = (value)=>{
        formik.setFieldValue('tanggal',value);
        setTimeout(() => {
            dispatch(getNewIDPenjualan(format(value,'ddMMyy'),token));
            formik.setFieldValue('nofaktur',nofaktur);
        }, 500);
    }
    const handleChangeJatuhTempo = (e) =>{
        formik.setFieldValue('jatuhtempo',e);
    }
    const [openDelete,setOpenDelete]=useState(false);
    const [tempIdBarang,setTempIdBarang]=useState('');
    const openDeletePenjualan = (idbarang,namabarang) =>{
        setNamaItem(namabarang);
        setOpenDelete(true);
        setTempIdBarang(idbarang);
    }
    const deleteDaftarPenjualan = () =>{
        const findBarang = listPenjualan.findIndex(barang=>barang.idbarang===tempIdBarang);
        listPenjualan.splice(findBarang,1);
        const findBarangKeuntungan = listKeuntungan.findIndex(barang=>barang.idbarang===tempIdBarang);
        listKeuntungan.splice(findBarangKeuntungan,1);
        dispatch(getAllListPenjualan());
        setTempIdBarang('');
        setOpenDelete(false);
        if(listPenjualan.length<1){
            formik.setFieldValue('ongkir',0);
            formik.setFieldValue('diskon',0);
        }
    }
    const onCloseDialog=()=>{
        setOpenDelete(false);
    }
    const handleOpenStatusLockOngkir = () =>{
        setStatusLockOngkir(!statusLockOngkir)
    }
    const handleOpenStatusLockDiskon = () =>{
        setStatusLockDiskon(!statusLockDiskon);
    }
    const onEnterLamaTempo = (value)=>{
        const newJatuhTempo = addDays(new Date(),value);
        formik.setFieldValue('lamatempo',value);
        formik.setFieldValue('jatuhtempo',newJatuhTempo);
    }
    const dataPembayaran =[
        {id:'Tunai',tipe:'Tunai'},
        {id:'Kredit',tipe:"Kredit"}
    ]
    const [openPrint,setOpenPrint]=useState(false);
    const HandleClickCloseFormPrintPenjualan = () =>{
        dispatch(resetAllFormPenjualan());
        setOpenPrint(false);
        history.push('/historyPenjualan');
    }
    const history = useHistory();
    const handleClickForwardLink = () =>{
        setTimeout(()=>{
            let RFrom = "Penjualan";
            dispatch(resetAllFormPenjualan());
            dispatch(getDataToPrint(nofaktur,token));
            history.push(`/PrintPenjualan/${RFrom}/${nofaktur}`);
        },2000)
    }
    const handleOpenDraftDialog = () =>{
        dispatch(getAllListPenjualanFromDraft(token,setOpenSnackbar));
        setOpenDraftDialog(true);
    }
    const handleCloseDraftDialog = () =>{
        dispatch(setEmptyLoadDraft());
        setOpenDraftDialog(false);
    }
    return (
        <div className={classes.root}>
            <div className={classes.mainWapper}>
                <div className={classes.blokFaktur}>
                    <DateField 
                        id="tanggal" 
                        name="tanggal" 
                        label="Tanggal" 
                        value={formik.values.tanggal}
                        errors={formik.touched.tanggal && Boolean(formik.errors.tanggal)}
                        helperText={formik.touched.tanggal && formik.errors.tanggal}
                        onChange={(e)=>handleChangeTanggal(e)}
                    />
                    <TextField className={classes.input} 
                    id="nofaktur" 
                    name="nofaktur" 
                    label="No Faktur"
                    value={nofaktur}
                    disabled={true}
                    />
                </div>
                <div className={classes.blokTempo}>
                    <PembayaranCombo
                    id="pembayaran"
                    name="pembayaran"
                    data={dataPembayaran}
                    label="Pembayaran"
                    value={formik.values.pembayaran}
                    error={formik.touched.pembayaran && Boolean(formik.errors.pembayaran)}
                    helperText={formik.touched.pembayaran && formik.errors.pembayaran}
                    handleChange={formik.handleChange}
                    />
                    <TextField className={classes.input}
                    id="lamatempo "
                    name="lamatempo"
                    label="Lama Tempo"
                    value={formik.values.lamatempo}
                    disabled={formik.values.pembayaran === 'Kredit' ? false : true}
                    error={formik.touched.lamatempo && Boolean(formik.errors.lamatempo)}
                    helperText={formik.touched.lamatempo && formik.errors.lamatempo}
                    onKeyDown={(e)=>{
                        if(e.key === 'Enter'){
                            onEnterLamaTempo(e.target.value);
                        }
                    }}
                    onChange={formik.handleChange}
                    /> 
                </div>
                <div className={classes.blokFaktur}>
                    <DateField 
                        id="jatuhtempo" 
                        name="jatuhtempo" 
                        label="Jatuh Tempo" 
                        disabled={true}
                        value={formik.values.jatuhtempo}
                        errors={formik.touched.jatuhtempo && Boolean(formik.errors.jatuhtempo)}
                        helperText={formik.touched.jatuhtempo && formik.errors.jatuhtempo}
                        onChange={(e)=>handleChangeJatuhTempo(e)}
                    />
                    <TextField className={classes.input}
                    id="namapelanggan"
                    name="namapelanggan"
                    label="Pelanggan"
                    value={formik.values.namapelanggan}
                    error={formik.touched.namapelanggan && Boolean(formik.errors.namapelanggan)}
                    helperText={formik.touched.namapelanggan && formik.errors.namapelanggan}
                    onChange={(e)=>formik.setFieldValue('namapelanggan',e.target.value.toUpperCase())}
                    />
                    <Tooltip title="Cari data pelanggan">
                        <IconButton className={classes.iconSearch} size='small' onClick={()=>handleClickOpenPelanggan()}>
                            <SearchIcon/>
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
            {dataPenjualan}
            <div className={classes.divinder}/>
            <div className={classes.content}>
                <div className={classes.OngkirWapper}>
                    <div className={classes.lock}>
                        <IconButton size="small" onClick={()=>handleOpenStatusLockOngkir()}>
                            {statusLockOngkir === true ? <LockIcon style={{'color':'red'}} fontSize="small"/> : <LockOpenIcon style={{'color':'blue'}} fontSize="small"/>}
                        </IconButton>
                        <TextField className={classes.input}
                        id="ongkir"
                        name="ongkir"
                        label="Ongkir"
                        disabled={statusLockOngkir}
                        value={formik.values.ongkir}
                        error={formik.touched.ongkir && Boolean(formik.errors.ongkir)}
                        helperText={formik.touched.ongkir && formik.errors.ongkir}
                        onChange={formik.handleChange}
                        InputProps={{
                            style:{fontSize:20,fontWeight:'bold'},
                            inputComponent: NumberFormatCustom
                        }}
                        />
                    </div>
                    <div className={classes.lock}>
                        <IconButton size="small" onClick={()=>handleOpenStatusLockDiskon()}>
                                {statusLockDiskon === true ? <LockIcon style={{'color':'red'}} fontSize="small"/> : <LockOpenIcon style={{'color':'blue'}} fontSize="small"/>}
                        </IconButton>
                        <TextField className={classes.input}
                        id="diskon"
                        name="diskon"
                        label="Diskon"
                        disabled={statusLockDiskon}
                        value={formik.values.diskon}
                        error={formik.touched.diskon && Boolean(formik.errors.diskon)}
                        helperText={formik.touched.diskon && formik.errors.diskon}
                        onChange={formik.handleChange}
                        InputProps={{
                            style:{fontSize:20,fontWeight:'bold'},
                            inputComponent: NumberFormatCustom
                        }}
                        />
                    </div>
                </div>
                <div className={classes.GrandTotal}>
                <Typography>Grand Total</Typography>
                <Typography><b>{new Intl.NumberFormat().format(grandTotal)}</b></Typography>
            </div>
            <Button 
            aria-label="save penjualan" 
            onClick={formik.handleSubmit} 
            variant="contained" 
            color="primary"
            disabled={
                loadingPenjualan === false ?
                listPenjualan.length > 0 && statusLockDiskon === true && statusLockOngkir === true ? false : true
                : true
            }
            >
                {loadingPenjualan === true ? "Tunggu..." : "Simpan Penjualan"}</Button>
            </div>
            <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={()=>handleCloseSnackBar}>
                <Alert onClose={handleCloseSnackBar} 
                severity={messagePenjualan === "Data penjualan berhasil disimpan" ? "success" : "error"}
                >
                    {messagePenjualan}
                    </Alert>
            </Snackbar>
            <div className={classes.divinder}/>
            <SingleDialog openDialog={openDelete} handleClick={deleteDaftarPenjualan} okCommand="Hapus" handleCloseDialog={onCloseDialog} message={"Anda yakin akan menghapus data "+namaItem+"?"}/>
            <DataPelanggan open={openPelanggan} aria-labelledby="data-pelanggan" HandleClickClosePelangganDialog={handleClosePelanggan}/>
            <PrintDialog 
            open={openPrint} 
            aria-labelledby="Print-dialog"
            judul="Print Penjualan" 
            content="Apakah anda akan melakukan print faktur penjualan?"
            forwardLink={()=>handleClickForwardLink()}
            HandleClickClosePrintDialog={HandleClickCloseFormPrintPenjualan}/>
            <GetDataDraft OpenDraftListDialog={openDraftDialog} formikEdit={formik} CloseDraftListDialog={handleCloseDraftDialog} aksesfrom="Penjualan"/>
            
        </div>
    )
}

export default KeranjangPenjualan
